import { styled } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";

export const CustomDatePicker = styled(DatePicker)(({ error, sizeMedium }) => ({
  "& input": {
    padding: "12px",
  },
  "& .MuiInputBase-root.MuiOutlinedInput-root": {
    borderRadius: "8px",
    padding: "0px",
  },
  "& fieldset": {
    border: error ? "1px solid #d32f2f" : "1px solid #D0D5DD",
  },
  "& .MuiInputAdornment-root": {
    height: "100%",
    maxHeight: "none",
    borderLeft: "1px solid #D0D5DD",
    margin: "0px",
    paddingRight: "12px",
  },
  "& .MuiIconButton-edgeEnd": {
    borderRadius: "0px",
  },
  "& button.Mui-disabled": {
    backgroundColor: "#F2F4F7",
    height: "100%",
  },
  "& label.MuiInputLabel-sizeMedium": {
    top: sizeMedium,
  },
  "& label.MuiInputLabel-shrink": {
    top: "0px",
  },
}));

export const CustomImg = styled("img")(({ width, height }) => ({
  width: width,
  height: height,
}));
